import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.5 3.9-5.5 3.9-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.9 1.5l2.6-2.5C16.8 3.4 14.6 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12S6.7 21.6 12 21.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z" />
    <path fill="#4285F4" d="M21 12.2c0-.6-.1-1.1-.2-1.6H12v3.9h5.5c-.2 1.1-.8 2.1-1.8 2.8l2.9 2.3c1.7-1.6 2.4-3.9 2.4-7.4z" opacity=".9" />
    <path fill="#34A853" d="M12 21.6c2.6 0 4.8-.9 6.4-2.3l-2.9-2.3c-.8.6-1.9 1-3.5 1-3.9 0-5.3-2.6-5.5-3.9H3.5v2.4c1.6 3.1 4.8 5.1 8.5 5.1z" opacity=".9" />
    <path fill="#FBBC05" d="M6.5 14.1c-.3-.8-.4-1.4-.4-2.1s.2-1.4.4-2.1V7.5H3.5C2.8 8.9 2.4 10.4 2.4 12s.4 3.1 1.1 4.5l3-2.4z" opacity=".9" />
  </svg>
);

export const GoogleButton = ({ next, label = "Continuar con Google" }) => {
  const { loginWithGoogle } = useAuth();
  return (
    <Button type="button" onClick={() => loginWithGoogle(next)} data-testid="google-login-btn"
      className="w-full h-12 rounded-full bg-white text-slate-800 border border-slate-300 hover:bg-slate-50 hover:border-slate-400 shadow-sm font-semibold transition-colors">
      <GoogleIcon /> <span className="ml-2">{label}</span>
    </Button>
  );
};

export const OrDivider = () => (
  <div className="flex items-center gap-3 text-xs text-slate-400 my-5">
    <span className="h-px flex-1 bg-slate-200" /> o <span className="h-px flex-1 bg-slate-200" />
  </div>
);
